import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

interface SortableItemProps {
  id: string;
  children: React.ReactNode;
}

export function SortableItem({ id, children }: SortableItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 50 : "auto",
    opacity: 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative flex items-center gap-3 w-full border border-border rounded-xl p-3 ${
        isDragging ? "bg-background shadow-lg shadow-black/50 border-primary" : "bg-bginput"
      }`}
    >
      <div
        {...attributes}
        {...listeners}
        className="touch-none flex items-center justify-center p-2 cursor-grab active:cursor-grabbing hover:bg-black/5 rounded-md text-secondary"
      >
        <GripVertical size={20} />
      </div>
      <div className="flex-1 min-w-0">
        {children}
      </div>
    </div>
  );
}
